const appKey = "game_rally"
const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}`,
  appInfo: {
    name: "GameRally独立游戏创作市集",
    description: "今年的GameJam活动重新升级，等你来哦！",
    shareTitle: "超有趣的游戏市集 GameRally 来了！9月初我们北京见",
    shareDescription: "感谢 波克城市 对本次活动的独家冠名支持，期待与大家相见",
  },
  url: {
    creatorEnroll: 'http://sparkidea.mikecrm.com/6FYkiTd',
    volunteerEnroll: 'http://sparkidea.mikecrm.com/VGclqhc',
    article: 'https://www.gcores.com/articles/139470',
    poster: 'https://site.gcores.com/vendors/game-rally-share-poster.png',
    team: 'https://www.gcores.com/topics/192',
    ticket: 'https://www.gcores.com/articles/140046',
    // ticket: 'https://detail.damai.cn/item.htm?id=651686409134',

    discuss: 'https://www.gcores.com/topics/196',
  }
}
